import { render } from "./ArrowSwitch.vue?vue&type=template&id=22ff0d4b"
const script = {}

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__